<template>
  <div>
    <v-card>
      <v-toolbar color="primary" dark class="mb-4 v-toolbar-header">
        <v-toolbar-title aling="center">Maestro de Usuarios</v-toolbar-title>
      </v-toolbar>
      <v-card flat>
        <v-btn absolute dark fab top right color="success" @click="dialog = true">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-card-text>
          <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" single-line
            hide-details></v-text-field>
          <v-data-table :headers="headers" :items="datos" :items-per-page="5" class="elevation-1 custom-font"
            :search="search">
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
              <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-card>

    <v-dialog v-model="dialog" max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
          <v-spacer></v-spacer>
          <v-switch :label="editedItem.isActive ? 'Activo' : 'Inactivo'" v-model="editedItem.isActive" color="success"
            v-if="editedIndex > -1" class="mr-4 mt-0" hide-details></v-switch>

          <v-switch label="¿Es Empleado?" v-model="isEmployee" color="success" class="mt-0" hide-details></v-switch>

        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-autocomplete v-model="employee" :items="employeesItems" label="Empleado" outlined auto-select-first
                  v-if="editedItem.userId || isEmployee"></v-autocomplete>
              </v-col>
              <v-col cols="6">
                <v-text-field v-model="editedItem.fullName" label="Nombres" required outlined></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field v-model="editedItem.email" label="Email" required outlined></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field v-model="editedItem.username" label="Usuario" required outlined></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-autocomplete v-model="editedItem.zoneId" :items="zonesItems" label="Zona de Inventario" outlined
                  auto-select-first></v-autocomplete>
              </v-col>
              <v-col cols="4">
                <v-select :items="niveles" v-model="editedItem.level" label="Nivel de Usuario" outlined></v-select>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-btn color="blue darken-1" text @click="restablecer">Reiniciar Clave</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
          <v-btn color="blue darken-1" text @click="presave">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
import swal from "sweetalert";
import api from "../conf/ruta-base";
import store from "../store";
import { host } from "../tools";
import { getEmployees, getInventoryZonesItems } from "../dataApi";
export default {
  name: "usuarios",
  data: () => ({
    apiPath: "/users",
    search: "",
    dialog: false,
    headers: [
      { text: "Nombre", align: "start", sortable: true, value: "fullName" },
      { text: "Usuario", value: "username" },
      { text: "Nivel", value: "level" },
      { text: "Correo", value: "email" },
      { text: "Acciones", value: "actions", sortable: false }
    ],
    datos: [],
    selec: '',
    niveles: [
      { text: 'Administrador', value: 'admin' },
      { text: 'Solicitante', value: 'user' },
      { text: 'Supervisor', value: 'sup' },
      { text: 'RRHH', value: 'rrhh' },
    ],
    instituciones: [],
    editedIndex: -1,
    defaultItem: {},
    employees: [],
    employeesItems: [],
    employee: null,
    zonesItems: [],
    zone: null,
    editedItem: null,
    isEmployee: false,

  }),
  created() {
    this.editedItem = Object.assign({}, this.defaultItem);
  },

  async mounted() {
    this.getUsers()
    this.zonesItems = await getInventoryZonesItems()
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nuevo Usuario" : "Modificar Usuario";
    }
  },
  methods: {

    async getUsers() {
      this.datos = []
      const data = await axios.get(api.api + this.apiPath)
      this.datos = data.data
    },

    editItem(item) {
      this.editedIndex = this.datos.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.isEmployee = this.editedItem?.employee?.id ? true : false
      this.employee = this.editedItem?.employee?.id
      console.log(this.editedItem)

      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    presave() {
      let bandera = true
      let err = ''
      if (bandera && this.editedItem.fullName.length == 0) {
        bandera = false
        err = 'Debe ingresar el nombre.'
      }

      if (bandera && this.editedItem.username.length == 0) {
        bandera = false
        err = 'Debe especificar el nombre de usuario'
      }

      if (bandera && this.editedItem.email.length == 0) {
        bandera = false
        err = 'Debe ingresar el correo'
      }

      if (bandera && this.editedItem.level.length == 0) {
        bandera = false
        err = 'Ingrese el nivel'
      }

      if (bandera && this.editedItem.zoneId.length == 0) {
        bandera = false
        err = 'Ingrese la zona'
      }

      if (bandera) {
        this.save()
      } else {
        swal('', err, 'error');
      }

    },

    async save() {
      if (this.editedIndex > -1) {
        console.log(this.employee, this.editedItem.employee?.id)
        if (this.employee) {
          this.editedItem.employeeId = this.employee
          this.editedItem.employee = this.employee
        } else {
          this.editedItem.employeeId = null
          this.editedItem.employee = null
        }
        console.log(this.employee, this.editedItem.employeeId)
        console.log(this.employee, this.editedItem.employeeId, this.editedItem)
        let index = this.editedIndex
        Object.assign(this.datos[this.editedIndex], this.editedItem)
        await axios
          .patch(api.api + this.apiPath + '/' + this.editedItem.id, this.editedItem)
          .then(res => {
            this.toast('success', 'Usuario Actualizado');
          })
          .catch(error => {
            console.log(error);
          });
      } else {
        this.editedItem.password = this.editedItem.username
        await axios
          .post(api.api + this.apiPath, this.editedItem)
          .then(res => {
            this.getUsers()
          })
          .catch(error => {
            console.log(error);
          });
      }
      this.close();
    },

    deleteItem(item) {
      const index = this.datos.indexOf(item)
      swal({ text: "¿Seguro que desea eliminar?", icon: "warning", buttons: ["Cancelar", "Ok"], })
        .then(ok => {
          if (ok) {
            axios.delete(api.api + this.apiPath + '/' + item.id)
              .then(res => {

                this.datos.splice(index, 1)

                this.toast('success', 'Usuario Eliminado');
              })
              .catch(error => {
                console.log(error);
              });
          }
        })
    },

    restablecer() {
      axios
        .post(api.api + '/users/force-pass/' + this.editedItem.id, {
          ...this.editedItem,
          host: host()
        })
        .then(res => {
          this.toast(res.data.c, res.data.mensaje);
        })
        .catch(error => {
          console.log(error);
        });
      this.close()
    },

    toast(color, text) {
      var toast = { color, text };
      store.commit("TOAST", toast);
    }
  },
  watch: {
    async isEmployee(value) {
      if (value && this.employees.length === 0) {
        ({ employees: this.employees, employeesItems: this.employeesItems } = await getEmployees());
      } else if (!value) {
        this.employee = null
        if (this.editedItem?.employeeId) this.editedItem.employeeId = null
      }
    },
    employee(value, oldValue) {
      if (!value || value === oldValue) return
      const employee = this.employees.find(emp => emp.id === value)
      this.editedItem.employeeId = employee.id
      this.editedItem.fullName = `${employee.firstName} ${employee.fatherName} ${employee.motherName}`;
      this.editedItem.username = employee.rut
      this.editedItem.email = employee.email.toUpperCase();
      this.editedItem.level = 'user'
      if (employee.email.includes(employee.rut)) swal('Email', 'No logramos validar que el e-mail sea correcto, favor verificar', 'warning');
    }
  }
};
</script>

<style>
.custom-font {
  font-family: 'Your Font Family', sans-serif;
  font-size: 16px;
  text-transform: uppercase;
}
</style>